/**
 * Утилиты для работы с TURN credentials
 * Изолированная логика получения и валидации ICE серверов
 */

/**
 * Получает TURN credentials с сервера
 */
export async function fetchTurnCredentials(token: string): Promise<RTCIceServer[]> {
  try {
    const response = await fetch('/api/turn-credentials', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch TURN credentials');
    }

    const { iceServers } = await response.json();
    
    if (!Array.isArray(iceServers)) {
      console.warn('⚠️ Получен невалидный массив ICE servers, используем STUN fallback');
      return getStunFallbackServers();
    }

    return iceServers;
  } catch (error) {
    console.error('❌ Ошибка получения TURN credentials:', error);
    console.log('🔄 Используем STUN fallback');
    return getStunFallbackServers();
  }
}

/**
 * Возвращает базовые STUN серверы в качестве fallback
 */
function getStunFallbackServers(): RTCIceServer[] {
  return [
    { urls: 'stun:stun.l.google.com:19302' },
    { urls: 'stun:stun1.l.google.com:19302' }
  ];
}

/**
 * Валидирует конфигурацию ICE серверов
 */
export function validateIceServers(servers: RTCIceServer[]): RTCIceServer[] {
  return servers.filter(server => {
    if (!server.urls) {
      console.warn('⚠️ ICE server без urls:', server);
      return false;
    }
    
    // Проверяем, что есть хотя бы один валидный URL
    const urls = Array.isArray(server.urls) ? server.urls : [server.urls];
    const hasValidUrls = urls.some(url => 
      typeof url === 'string' && 
      (url.startsWith('stun:') || url.startsWith('turn:') || url.startsWith('turns:'))
    );
    
    if (!hasValidUrls) {
      console.warn('⚠️ ICE server без валидных URLs:', server);
      return false;
    }
    
    return true;
  });
}

